import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { getConversationSnapshotAPI } from '../../../api/supportChat';
import SupportWidgetKeys from '../queryKeys';

const { getConversationSnapshot } = SupportWidgetKeys;

const transformFiltersForApi = filters => {
  const {
    dateRange,
    includeProductionHubs,
    includeSuperadmin,
    includeClientAdmin,
    includeNonAdminUsers,
  } = filters;

  const apiFilters = {
    includeProductionHubs: includeProductionHubs !== false,
    includeSuperadmin: includeSuperadmin === true,
    includeClientAdmin: includeClientAdmin !== false,
    includeNonAdminUsers: includeNonAdminUsers !== false,
  };

  // Add dateFrom and dateTo if dateRange exists
  if (dateRange && dateRange.start && dateRange.end) {
    apiFilters.dateFrom = moment(dateRange.start)
      .startOf('day')
      .utc()
      .toISOString();
    apiFilters.dateTo = moment(dateRange.end).endOf('day').utc().toISOString();
  }

  return apiFilters;
};

const conversationSnapShotApi = async filters => {
  const apiFilters = transformFiltersForApi(filters);
  const response = await getConversationSnapshotAPI(apiFilters);
  return response.data;
};

const useConversationSnapshotMetrics = filters => {
  const { data, isLoading, isError } = useQuery(
    [
      getConversationSnapshot,
      filters.dateRange?.start,
      filters.dateRange?.end,
      filters.includeProductionHubs,
      filters.includeSuperadmin,
      filters.includeClientAdmin,
      filters.includeNonAdminUsers,
    ],
    () => conversationSnapShotApi(filters),
    { retry: false }
  );

  return { data, isLoading, isError };
};

export default useConversationSnapshotMetrics;
